export default __webpack_public_path__ + "static/media/workout-1.804e3533.png";